export default {
  mediaMix: 'Mix de Medios',
  dataView: 'Vista de Datos',
  close: 'Cerrar',
  refresh: 'Actualizar',
  saveAsImage: 'Guardar como Imagen'
}
